<template>
    <div class="pagestock" v-loading="loadingallocation" element-loading-background="rgba(0, 0, 0, 0.1)">
        <!--
        <el-row v-if="allocations" class="toprow is-text-align-right">
            <el-select
                v-if="isadmin"
                v-model="activeAllocationId"
                placeholder="Select"
                style="width: 300px"
            >
                <el-option
                    v-for="allocation in allocations"
                    :key="'liv' + allocation.id"
                    :label="
                        allocation.annee +
                            '/' +
                            (parseInt(allocation.annee) + 1).toString()
                    "
                    :value="allocation.id"
                />
            </el-select>
        </el-row>
        -->
        <h1 v-if="allocation" v-loading="loadingallocation">
            Allocation {{ allocation.annee
            }}<span v-if="allocation.annee"
                >/{{ parseInt(allocation.annee) + 1 }}</span
            >
            <span
                class="millesime"
                v-if="allocation.millesime"
                v-html="', Millésime ' + allocation.millesime"
            />
        </h1>
        <div v-if="edituserid">
            <h2 class="soustitre">ÉDITION DU PANIER DE : {{ panier.user }}</h2>
            <h2 class="soustitre">
                <el-button
                    type="success"
                    class="button"
                    @click.native.prevent="
                        $router.push(
                            '/allocataires/edit/' + edituserid + '#allocations'
                        )
                    "
                >
                    Retour
                </el-button>
            </h2>
        </div>
        <div v-else-if="allocation"  v-loading="loadingallocation">
            <p class="description" v-html="showShort ? shortDescription : allocation.description" />
            <!--
            <p v-else v-html="allocation.description" />
            -->
            <p style="text-align:center">
                <el-button
                    class="button readmore"
                    @click="showShort = !showShort"
                    v-text="showShort ? 'Lire plus' : 'Lire moins'"
                    round
                />
            </p>
            <h2
                v-if="panier && panier.etat == 'avalider'"
                class="soustitre"
                v-html="options['allocation_avalider']"
            />
            <h2
                v-if="panier && panier.etat == 'valided'"
                class="soustitre"
                v-html="options['allocation_valided']"
            />
            <h2
                v-if="panier && panier.etat == 'livred'"
                class="soustitre"
                v-html="options['allocation_livred']"
            />
            <h2
                v-if="panier && panier.etat == 'payed'"
                class="soustitre"
                v-html="options['allocation_payed']"
            />
        </div>
        <div v-if="allocation && allocation.etat == 'attente'">
            <h2 class="soustitre" v-html="options['millesimeEnAttente']" />
        </div>
        <ul
            v-if="allocation && (allocation.etat == 'encours' || isadmin)"
            class="familles"
            :class="{
                paniervalided: panier && panier.etat != 'encours' && !edituserid
            }"
        >
            <li
                v-for="(famille, index) in familles"
                :id="famille.id"
                :key="'fa_' + index"
                v-loading="loading"
            >
                <template v-if="gotbouteilles(famille.id)">
                    <h3>{{ famille.nom }} ({{ famille.max }} max)</h3>
                    <ul class="bouteilles">
                        <template
                            v-for="(vin, indexvin) in vinsFam(famille.id)"
                            :id="vin.id"
                        >
                            <li
                                v-for="(bouteille, indexbouteille) in bouteillesVin(
                                    vin.id
                                )"
                                :id="'row' + bouteille.id"
                                :ref="'row' + bouteille.id"
                                :key="'bout_' + indexvin + indexbouteille"
                                :class="getclass(bouteille)"
                                class="linebouteille"
                            >
                                <el-row type="flex" :gutter="5">
                                    <el-col :span="1">
                                        <el-button
                                            size="mini icon"
                                            @click="
                                                toggleInfo(
                                                    'row' + bouteille.id,
                                                    $event
                                                )
                                            "
                                        >
                                            <svg-icon
                                                icon-class="wine-bottle-solid"
                                            />
                                        </el-button>
                                    </el-col>
                                    <el-col :span="14">
                                        <h4>
                                            <span v-if="bouteille.ismagnum">Magnum</span>
                                            {{ vin.nom }}
                                            {{ bouteille.millesime }}
                                        </h4>
                                    </el-col>
                                    <el-col :span="3" class="infos">
                                        <div class="textmini opacity7">
                                            {{ bouteille.max }} max
                                        </div>
                                        <div
                                            v-if="
                                                disponible(bouteille) &&
                                                    disponible(bouteille) < 5
                                            "
                                            class="textmini opacity7 isred"
                                        >
                                            plus que
                                            {{ disponible(bouteille) }}
                                            disp.
                                        </div>
                                        <div
                                            v-if="disponible(bouteille) <= 0"
                                            class="textmini opacity7"
                                        >
                                            épuisé
                                        </div>
                                    </el-col>
                                    <el-col
                                        :span="3"
                                        class="is-text-align-right prix"
                                    >
                                        {{ bouteille.prixttc | formatPrix }} € ttc
                                    </el-col>
                                    <el-col
                                        :span="3"
                                        class="is-text-align-right infos"
                                    >
                                        <el-button
                                            v-if="
                                                panier &&
                                                    nbDansPanier(bouteille.id) > 0
                                            "
                                            :type="
                                                nbDansPanier(bouteille.id) > 0
                                                    ? 'danger'
                                                    : 'success'
                                            "
                                            :disabled="ajouting"
                                            size="mini"
                                            icon="el-icon-minus"
                                            @click="enleveBouteille(bouteille.id)"
                                        />
                                        <el-button
                                            v-if="
                                                panier &&
                                                disponible(bouteille) > 0
                                            "
                                            :disabled="ajouting"
                                            :type="'success'"
                                            size="mini"
                                            icon="el-icon-plus"
                                            @click="ajoutBouteille(bouteille.id)"
                                        />
                                    </el-col>
                                    <template v-if="nbDansPanier(bouteille.id) > 0">
                                        <el-col :span="1">
                                            {{ nbDansPanier(bouteille.id) }}
                                        </el-col>
                                        <el-col
                                            :span="3"
                                            class="sstotal is-text-align-right"
                                        >
                                            {{
                                                (bouteille.prixttc *
                                                    nbDansPanier(bouteille.id))
                                                    | formatPrix
                                            }}
                                            €
                                        </el-col>
                                    </template>
                                    <template v-else>
                                        <el-col :span="4">
                                            &nbsp;
                                        </el-col>
                                    </template>
                                </el-row>
                                <el-row class="theinfo">
                                    <el-col :span="12">
                                        <el-image
                                            class="bouteille"
                                            :src="
                                                bouteille.photo
                                                    ? bouteille.photo_url.thumb
                                                    : '/storage/bouteilles_thumb/vide.jpg'
                                            "
                                            fit="scale-down"
                                        />
                                    </el-col>
                                    <el-col :span="12">
                                        <p v-html="bouteille.vin_description" />
                                    </el-col>
                                </el-row>
                            </li>
                        </template>
                    </ul>
                </template>

            </li>
        </ul>
        <ul v-else style="height:100vh">
        </ul>
        <el-dialog
            title="Validation téléphone"
            :visible.sync="dialogTelfix"
            :modal-append-to-body="true"
            :append-to-body="true"
            v-loading="telfixLoading"
        >
            <div class="form-container" v-if="panier">
                Livraison: {{ panier.livraison_adresse_label }}<br />
                Afin de procéder à la livraison,<br />
                merci de
                <span v-if="panier.telfix">valider</span>
                <span v-else>renseigner</span>
                 votre numéro de téléphone:
                <hr />
                <el-form
                    ref="telfixForm"
                    style="max-width: 600px;"
                    :model="panier"
                    :rules="rules"

                >
                    <el-form-item
                        prop="telfix"
                        label="Téléphone*"
                        :error="getErrorForField('telfix', errors)"
                    >
                        <el-input
                            v-model="panier.telfix"
                            name="telfix"
                            type="text"
                            auto-complete="off"
                            placeholder="Téléphone"
                            prefix-icon="el-icon-phone"
                        />
                    </el-form-item>
                </el-form>
                <div slot="footer" class="dialog-footer">
                    <el-button @click="dialogTelfix = false">
                        Annuler
                    </el-button>
                    <el-button type="primary" @click="validTelfix()">
                        Envoyer
                    </el-button>
                </div>
            </div>
        </el-dialog>
        <el-dialog
            title=" "
            :visible.sync="charteVisible"
            :append-to-body="true"
            :before-close="closedialog"
            class="charte"
        >
            <div v-html="options['allocations_charte']" />
            <div slot="footer" class="dialog-footer">
                <el-button @click="closedialog">Annuler</el-button>
                <el-button
                    v-loading="validloading"
                    type="success"
                    @click="validCharteAndCommand"
                    >Accepter et passer la commande</el-button
                >
            </div>
        </el-dialog>
    </div>
</template>
<script>
import Resource from "@/api/resource";
const familleResource = new Resource("familles");
const vinResource = new Resource("vins");
const bouteilleResource = new Resource("bouteilles");
const allocationResource = new Resource("allocations");
const panierResource = new Resource("paniers");
import { mapState } from "vuex";
import { findoptions } from "@/utils/options";

export default {
    name: "Stock",
    data() {
        return {
            loading: false,
            validloading: false,
            familles: null,
            vins: null,
            bouteilles: null,
            allocation: null,
            allocations: [],
            // shortDescription: null,
            showShort: true,
            activeAllocation: {},
            activeAllocationId: null,
            pasdeallocation: null,
            // panier: null,
            pasdepanier: null,
            charteVisible: false,
            edituserid: false,
            dialogTelfix: false,
            telfixLoading: false,
            loadingallocation: true,
            options: { // par defaut, seront chargé...
                allocations_charte: "",
                allocation_avalider: "Allocation en cours de validation",
                allocation_valided: "Allocation validée",
                allocation_livred: "Allocation en livraison",
                allocation_payed: "Allocation payée",
                millesimeEnAttente: "en préparation"
            },
            errors: [],
            rules: {
                telfix: {}
            },
            ajouting: false,
        };
    },
    created() {
        findoptions(this.options, this);
    },
    mounted() {
        this.loading = true;
        this.currentAllocation();
        // this.getFamilles();
        // this.getVins();
        // this.getBouteilles();
        this.edituserid = this.$route.params && this.$route.params.id;
        console.log("userid---->" + this.edituserid);
        // this.currentPanier(

        /*
        if (this.isadmin){
            this.getAllocations();
        } else {
            this.currentAllocation();
        }
        */
    },
    computed: {
        ...mapState({
            isadmin: state => state.user.isadmin,
            panier: state => state.user.panier,
            sendpanier: state => state.app.sendpanier
        }),
        anneeallocation() {
            if (this.pasdeallocation) {
                return "pas de allocation";
            }
            if (this.allocation) {
                return this.allocation.annee;
            }
            return "";
        },
        panierId() {
            if (this.pasdepanier) {
                return "pas de panier";
            }
            if (this.panier) {
                return this.panier.id;
            }
            return "..";
        },
        shortDescription() {
            if(this.allocation && this.allocation.description){
                return this.allocation.description.substring(
                    0,
                    this.allocation.description.indexOf(".", 200)
                ) + " ...";
            }else{
                return "";
            }
        }
    },
    watch: {
        sendpanier(val) {
            //vient de carton
            if (val) {
                this.dialogTelfix = true;
                // this.charteVisible = true;
                this.$store.dispatch("app/setSendpanier", false);
            }
        },
        activeAllocationId(val) {
            if (val && this.allocations) {
                this.activeAllocation = this.allocations.find(
                    allocation => allocation.id === val
                );
                console.log(this.activeAllocationId);
                console.log(this.activeAllocation);
                this.allocation = this.activeAllocation;
                this.getBouteilles(val);
                this.currentPanier(val);
            }
        }
    },
    methods: {
        callbackoptions(slug, data) {
            this.options[slug] = data;
        },
        closedialog() {
            console.log("opendialog");
            this.charteVisible = false;
        },
        toggleInfo(ref) {
            // console.log(ref);
            // console.log(this.$refs[ref]);
            // console.log(document.getElementById(ref));
            // console.log(event);
            document.getElementById(ref).classList.toggle("theinfoshowed");
        },
        nbDansPanier(bouteille_id) {
            if (this.panier && this.panier.bouteilles) {
                var bouteilleInPanier = this.panier.bouteilles.find(
                    bouteille => bouteille.id === bouteille_id
                );
                if (bouteilleInPanier && bouteilleInPanier.pivot) {
                    return bouteilleInPanier.pivot.quantite;
                }
                return 0;
            }
            return 0;
        },
        disponible(mabouteille) {
            var monajout = 0;
            //en prévision de mon ajout
            if (mabouteille && this.panier && this.panier.bouteilles) {
                var bouteilleInPanier = this.panier.bouteilles.find(
                    bouteille => bouteille.id === mabouteille.id
                );
                if (bouteilleInPanier && bouteilleInPanier.pivot) {
                    monajout = bouteilleInPanier.pivot.quantite;
                }
            }
            return mabouteille.disponibles - monajout;
        },
        finloading() {
            console.log("finloading");
            if (
                this.familles &&
                this.vins &&
                this.bouteilles &&
                (this.allocation || this.pasdeallocation) &&
                (this.panier || this.pasdepanier)
            ) {
                this.loading = false;
            }
            console.log(this.loading);
        },
        ajoutBouteille(bouteille_id) {
            console.log("addBouteille" + bouteille_id);
            this.ajouting= true;
            panierResource
                .update(this.panier.id, { ajout: bouteille_id })
                .then(response => {
                    this.$message({
                        message: response.message
                            ? response.message
                            : "Bouteille ajoutée",
                        type: response.message ? "error" : "success",
                        duration: 2 * 1000
                    });
                    if (response.data && response.data.id) {
                        // this.panier = response.data;
                        this.$store.dispatch("user/setPanier", response.data);
                    }
                    this.ajouting= false;
                })
                .catch(error => {
                    console.log(error);
                    this.$message({
                        message: "Erreur d'ajout",
                        type: "error",
                        duration: 2 * 1000
                    });
                    this.ajouting= false;
                });
        },
        enleveBouteille(bouteille_id) {
            console.log("enleveBouteille" + bouteille_id);
            this.ajouting= true;
            panierResource
                .update(this.panier.id, { enleve: bouteille_id })
                .then(response => {
                    this.$message({
                        message: response.message
                            ? response.message
                            : "Bouteille retiré",
                        type: response.message ? "error" : "success",
                        duration: 2 * 1000
                    });
                    if (response.data && response.data.id) {
                        // this.panier = response.data;
                        this.$store.dispatch("user/setPanier", response.data);
                    }
                    this.ajouting= false;
                })
                .catch(error => {
                    console.log(error);
                    this.$message({
                        message: "Erreur",
                        type: "error",
                        duration: 2 * 1000
                    });
                    this.ajouting= false;
                });
        },
        getErrorForField(field, errors) {
            if (errors && errors[field]) {
                return errors[field].join(" ");
            }
        },
        validTelfix() {
            console.log("validTelfix");
            if (!this.panier.telfix) {
                /*
                this.$message({
                    message: "Le téléphone est obligatoire",
                    type: "error",
                    duration: 4 * 1000
                });
                */
                this.errors = {
                    telfix: [
                        "Le téléphone est obligatoire."
                    ]
                }
                return false;
            }
            this.telfixLoading = true;
            panierResource
                .update(this.panier.id, { telfix: this.panier.telfix })
                .then(response => {
                    console.log("tel change");
                    console.log(response.data);
                    this.telfixLoading = false;
                    this.charteVisible = true;
                    this.dialogTelfix = false;
                    this.$message({
                        message: "Téléphone validé",
                        type: "success",
                        duration: 5 * 1000
                    });
                    if (response.data && response.data.id) {
                        // this.panier = response.data;
                        this.$store.dispatch("user/setPanier", response.data);
                    }
                })
                .catch(error => {
                    console.log("error");
                    console.log(error.response);
                    if (error.response && error.response.data) {
                        // this.errors = error.response.data.errors;
                        Object.assign(this.errors, error.response.data.errors);
                    }
                    console.log("errores");
                    console.log(this.errors);
                    this.$message({
                        message: "Erreur dans le téléphone",
                        type: "error",
                        duration: 2 * 1000
                    });
                    this.telfixLoading = false;
                });
        },

        validCharteAndCommand() {
            console.log("validCharteAndCommand");
            this.validloading = true;
            panierResource
                .update(this.panier.id, { valider: 1 })
                .then(response => {
                    console.log("response");
                    console.log(response.data);
                    this.sending = false;
                    this.charteVisible = false;
                    this.$message({
                        message: "Commande envoyée",
                        type: "success",
                        duration: 5 * 1000
                    });
                    if (response.data && response.data.id) {
                        // this.panier = response.data;
                        this.$store.dispatch("user/setPanier", response.data);
                    }
                    this.sended = true;
                    this.validloading = false;
                })
                .catch(error => {
                    console.log(error);
                    this.charteVisible = false;
                    this.sending = false;
                    this.$message({
                        message: "Erreur dans la validation",
                        type: "error",
                        duration: 2 * 1000
                    });
                    this.validloading = false;
                });
        },
        async getFamilles() {
            console.log("getFamilles");
            const { data } = await familleResource.list({});
            console.log("getFamillesdata");
            console.log(data);
            this.familles = data;
            this.finloading();
        },
        async getVins() {
            console.log("getVins");
            const { data } = await vinResource.list({ envente: 1 });
            console.log("getVinsdata");
            console.log(data);
            this.vins = data;
            this.finloading();
        },
        async getBouteilles(allocation_id) {
            console.log("getBouteilles");
            const { data } = await bouteilleResource.list({ envente: 1, allocation_id: allocation_id });
            console.log("getBouteillesdata");
            console.log(data);
            this.bouteilles = data;
            this.finloading();
        },
        // pour allocataires
        async currentAllocation() {
            console.log("currentAllocation");
            const { data } = await allocationResource.list({ envente: 1 });
            console.log("currentAllocationdata");
            console.log(data);
            this.allocation = data;
            if (!this.allocation) {
                this.loadingallocation = false;
                this.getAllocationEnAttente();
                this.pasdeallocation = true;
            } else {
                this.loadingallocation = false;
                this.getBouteilles(this.allocation.id);
                this.currentPanier(this.allocation.id);
                this.getFamilles();
                this.getVins();

            }

            this.finloading();
        },
        async getAllocationEnAttente() {
            console.log("enAttenteAllocation");
            const { data } = await allocationResource.list({ enattente: 1 });
            console.log("enAttenteAllocationdata");
            console.log(data);
            this.allocation = data;
            if (!this.allocation) {
                this.loadingallocation = false;
                this.pasdeallocation = true;
            } else if(this.isadmin) {
                this.getBouteilles(this.allocation.id);
                this.currentPanier(this.allocation.id)
                this.getFamilles();
                this.getVins();
            }

            this.finloading();
        },
        // pour admins
        async getAllocations() {
            console.log("getAllocations");
            this.activeAllocation = null;
            this.activeAllocationId = null;
            this.loading = true;
            const { data } = await allocationResource.list({});
            this.allocations = data;
            this.activeAllocation = data[0];
            this.activeAllocationId = data[0].id;
            this.allocation = this.activeAllocation;
            this.loadingallocation = false;
            this.getBouteilles(this.allocation.id);
            this.currentPanier(this.allocation.id);
            this.getFamilles();
            this.getVins();
            this.loading = false;
            console.log("ALLOCATIONS");
            console.log(this.allocations);
        },
        getShortDescription(){
            this.shortDescription = this.allocation.description.substring(0,30);
        },
        //////
        async currentPanier(allocation_id) {
            console.log("currentPanier");
            var $params = this.edituserid
                ? { user_id: this.edituserid, allocation_id: allocation_id }
                : { envente: 1, allocation_id: allocation_id};
            const { data } = await panierResource.list($params);
            console.log("currentPanierdata");
            console.log(data);
            // this.panier = data;
            this.$store.dispatch("user/setPanier", data);

            if (!data) {
                this.pasdepanier = true;
            }
            this.finloading();
        },
        vinsFam(famille_id) {
            if (this.vins) {
                return this.vins.filter(vin => vin.famille_id === famille_id);
            }
            return [];
        },
        gotbouteilles(famille_id) {
            var b = 0;
            this.vinsFam(famille_id).forEach(vin => {

                this.bouteillesVin(vin.id).forEach(() => {
                    b++;
                });
            });
            return b;
        },
        bouteillesVin(vin_id) {
            if (this.bouteilles) {
                return this.bouteilles.filter(
                    bouteille => bouteille.vin_id === vin_id
                );
            }
            return [];
        },
        getclass(bouteille) {
            var classes = [];
            if (this.nbDansPanier(bouteille.id) > 0) {
                classes.push("danspanier");
            }

            if (this.disponible(bouteille)) {
                classes.push("envente");
            } else {
                classes.push("epuise");
            }
            return classes.join(" ");
        }
    }
};
</script>
